module.exports = "data:image/gif;base64,R0lGODlhAwACAIAAAP///wAAACH5BAEAAAAALAAAAAADAAIAAAIChF8AOw=="


//////////////////
// WEBPACK FOOTER
// ./src/images/3x2.gif
// module id = 280
// module chunks = 0